import React, { useState } from 'react'
import { NumberInput } from './ui/NumberInput'

export const RectGrid = ({ onBorderRadiusChange, rect }) => {
    const [rad, setRad] = useState(rect.rx)
    const handleBorderRadiusChange = (value) => {
        setRad(value)
        onBorderRadiusChange({ obj: rect, value: value })
    }

    return (
        <>
            <NumberInput
                label="Border Radius"
                onChange={handleBorderRadiusChange}
                step={1}
                min={0}
                value={rad}
            />
        </>
    )
}
